// NodeTypes.js
import CustomSwitchNode from "./CustomSwitchNode";
import CustomGateNode from "./CustomGateNode";
import CompletionLightNode from "./CompletionLightNode";

const nodeTypes = {
  input: CustomSwitchNode,
  gate: CustomGateNode,
  output: CompletionLightNode,
};

export default nodeTypes;
